<div class="section" style="background-color: #f9fafd">
  <!-- <div class="row">
    <div class="col-sm">
      <div class="OR-section-header">
        <hr class="hr-tag-style" />
        <span class="hr-tag-text">OR</span>
        <hr class="hr-tag-style" />
      </div>
    </div>
  </div> -->

  <div class="row">
    <div class="col-sm">
      <!-- [formControl]="fileInput" -->
      <ng-container *ngIf="!filled">
        <div class="upload-icon-section">
          <!-- <input
            type="file"
            (change)="handleFileInput($event)"
            accept=".jpg, .png, .jpeg, .pdf, .docx, .pptx, .tiff"
          />
          <img src="{{ uploadIcon }}" height="50" width="50" /> -->
          <label for="file-upload">
            <img
              [attr.disabled]="isFieldsDisabled ? true : null"
              src="{{ uploadIcon }}"
              alt="Upload Icon"
              class="cursor-pointer"
            />
          </label>
          <input
            [attr.disabled]="isFieldsDisabled ? true : null"
            type="file"
            id="file-upload"
            (change)="handleFileInput($event)"
            accept=".jpg, .png, .jpeg, .pdf, .docx, .pptx, .ppt, .doc, .tif, .tiff"
            style="display: none"
          />
        </div>
        <div class="upload-text">
          <span>
            Upload any file (artwork/concept/any other asset) to extract the
            claims <br />
            <span class="format-text">
              All File formats are supported except Microsoft Excel.</span
            >
          </span>
        </div>
      </ng-container>
    </div>
  </div>

  <!-- <div class="row">
    <div class="col-sm">
      <div class="upload-icon-section">
        <hr class="hr-tag-style" />
        <span class="hr-tag-text">OR</span>
        <hr class="hr-tag-style" />
      </div>
    </div>
  </div> -->

  <div class="row">
    <div class="col-sm">
      <ng-container *ngIf="filled">
        <div class="file-icon">
          <span>{{ fileType }}</span>
        </div>
        <div class="upload-text">{{ fileToUpload.name }}</div>
        <img
          class="basket"
          src="{{ basketIcon }}"
          (click)="clear()"
          (mouseover)="isBasketHovered = true"
          (mouseout)="isBasketHovered = false"
        />
      </ng-container>
    </div>
  </div>
</div>
